/**
 * Local Development Detection
 *
 * Returns true when Cognito is NOT configured, meaning we're running
 * locally without deployed AWS resources. Used to gate mock data injection.
 *
 * IMPORTANT: When real resources are deployed (Cognito env vars present),
 * this always returns false — mock data is never used.
 */

export function isLocalDev(): boolean {
    return (
        !import.meta.env.VITE_COGNITO_USER_POOL_ID &&
        !import.meta.env.VITE_COGNITO_CLIENT_ID
    );
}
